import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getCustomerInteractionRequest,
  getCustomerInteractionSuccess,
  getCustomerInteractionFailure,
} from "./customerInteractionSlice";
import { toast } from "react-toastify";

function* fetchCustomerInteraction() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer-interaction/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
    );

    if (response.data.success) {
      yield put(getCustomerInteractionSuccess(response.data));
      // toast.success("Customer interaction fetched successfully");
    } else {
      yield put(
        getCustomerInteractionFailure(
          response.data.message || "Failed to fetch customer interaction"
        )
      );
      toast.error(response.data.message || "Failed to fetch customer interaction");
    }
  } catch (error) {
    yield put(getCustomerInteractionFailure(error.message));
    toast.error("Error fetching customer interaction");
  }
}

export function* customerInteractionSaga() {
  yield takeLatest(
    getCustomerInteractionRequest.type,
    fetchCustomerInteraction
  );
}
